import { loginUser } from "@/api/auth";
import { AuthCard } from "./AuthCard";
import { useSession } from "@clerk/clerk-react";
import { useEffect } from "react";
import { nextFromLocation, postLoginDestination } from "./returnTo";

export const ClerkVerify = () => {
  const { isSignedIn, session } = useSession();
  const loginClerkUser = async () => {

    const { id } = session?.user?.publicMetadata;
    const token = await session?.getToken();

    const data = await loginUser({ clerkToken: token, userId: id });

    if (data) {
      if (data.error) {
        alert(data.error);
      } else {
        console.log("the data", data);
        if (data?.token) {
          const { permissions } = data;
          let landing = "/funnels";
          if (permissions?.includes("agents")) landing = "/agents/home"; // Agents users land on the Agents home (AMB-309)
          else if (permissions?.includes("f$-internal")) landing = "/order-forms";
          else if (permissions?.includes("scroll")) landing = "/crm/contacts";
          else if (permissions?.includes("copilot")) landing = "/copilot"; // go to the copilot home screen after log in
          // LNK-1: back to the page they were trying to open, if they were sent to sign in from one
          window.location.href = postLoginDestination(nextFromLocation(), landing);
        } else {
          alert("Unable to login. Please try again.");
        }
      }
    }
  };

  useEffect(() => {
    if (isSignedIn && session) {
      loginClerkUser();
    }
  }, [isSignedIn, session]);

  return <AuthCard title="Signing you in..."><div className="ac-spin" role="status" aria-label="Signing in" /></AuthCard>;
};
